import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDbt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2427_61)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M46.5674 57.5294 L52.68 51.4159 C53.4439 50.6518 53.4439 49.429 52.68 48.5121 L46.5674 42.3986 C45.6505 41.4816 44.428 41.4816 43.5113 42.3986 L37.3987 48.5121 C36.6346 49.2762 36.6346 50.6518 37.3987 51.4159 L43.5113 57.5294 C44.2752 58.2936 45.6505 58.2936 46.5674 57.5294 ZM74.9904 6.0233 C78.9635 3.7309 83.2422 5.565 86.4514 8.7744 C89.8131 12.1368 91.1884 15.8051 89.0492 19.9317 C88.285 21.46 79.2691 37.0492 76.5185 41.4816 C74.9904 43.9269 74.2263 46.9838 74.2263 49.8876 C74.2263 52.7915 74.9904 55.8483 76.5185 58.4464 C79.2691 62.726 88.285 78.468 89.0492 79.9963 C91.1884 84.2759 89.6603 87.4854 86.6042 90.8478 C83.0894 94.363 79.5747 96.1971 75.296 93.9047 C73.7679 92.9875 30.9806 68.3809 30.9806 68.3809 C31.7448 73.4245 34.4953 78.0096 38.0101 80.7607 C37.5515 80.9135 16.3909 93.1367 14.9354 93.9047 C10.9241 96.021 7.2662 94.606 4.0856 91.612 C0.4944 88.2312 -1.2627 84.2759 1.0295 80.1493 C1.7937 78.6208 10.8096 62.8788 13.4074 58.5994 C14.9354 56.0011 15.8521 53.0973 15.8521 50.0404 C15.8521 46.9838 14.9354 44.0799 13.4074 41.6344 C10.8096 37.0492 1.7937 21.1542 1.0295 19.7787 C-1.2627 15.6521 0.5776 11.2197 3.7801 8.316 C7.4103 5.0246 10.8096 4.0367 14.9354 6.0233 C16.158 6.4819 58.7925 31.7001 58.7925 31.7001 C58.3339 26.8094 55.8889 22.3769 51.9158 19.3203 C52.2214 19.1673 73.4624 6.6347 74.9904 6.0233 Z",
				fill: "#FE6703"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 92.87,
				cy: 78.21,
				r: 1.863,
				fill: "none",
				stroke: "#FE6703",
				strokeWidth: .414
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 92.457 79.033 L 92.457 77.517 L 93.029 77.517 A 0.394 0.394 0 0 1 93.029 78.305 L 92.457 78.305 M 92.785 78.305 L 93.423 79.033",
				fill: "none",
				stroke: "#FE6703",
				strokeWidth: .414,
				strokeLinecap: "square",
				strokeLinejoin: "miter"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2427_61",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 100,
			height: 90,
			fill: "white",
			transform: "translate(0 5)"
		})
	}) })]
});
export default SvgDbt;
